import { render } from "./RedeemPrizesToast.vue?vue&type=template&id=7c70c5ac&scoped=true&bindings={}"
import script from "./RedeemPrizesToast.vue?vue&type=script&lang=ts"
export * from "./RedeemPrizesToast.vue?vue&type=script&lang=ts"

import "./RedeemPrizesToast.vue?vue&type=style&index=0&id=7c70c5ac&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-7c70c5ac"

export default script